@if (isEpcotEnabled) {
    <div class="show-more-button-container">
        <ng-container *ngTemplateOutlet="showMoreHideButton" />
    </div>
} @else {
    <ng-container *ngTemplateOutlet="showMoreHideButton" />
}

<ng-template #showMoreHideButton>
    <div class="show-more-button" [class.expanded]="isExpanded" (click)="onShowMoreLessButtonToggle()">
        {{ showMoreLessText }} <vn-icon size="12" [name]="isExpanded ? 'theme-up' : 'theme-down'"></vn-icon>
    </div>
</ng-template>
